import { routes } from 'constants/routes'
import WsNotifications from 'hooks/WsNotifications/WsNotifications'
import NoMatch from 'pages/NoMatch/NoMatch'
import { useEffect, useState  } from 'react'
import { Route, Routes } from 'react-router-dom'

console.log = console.warn = console.error = () => {};

console.info = () => {};
function App() {
  const handleContextMenu = (event) => {
    event.preventDefault();
  };
let devtoolsOpen = false;
const threshold = 160;
// setInterval(() => {
//     const widthThreshold = window.outerWidth - window.innerWidth > threshold;
//     const heightThreshold = window.outerHeight - window.innerHeight > threshold;
//     if (widthThreshold || heightThreshold) {
//       if (!devtoolsOpen) {
//         console.log('DevTools открыт!');
//         devtoolsOpen = true;
//         window.location.href = "https://www.youtube.com/watch?v=-IhG8-kmpHo";


//       }
//     } else {
//       devtoolsOpen = false;
//     }
//   }, 5000);

  // const handleMouseDown = (event) => {
  //   if (event.button === 2) {
  //     event.preventDefault();
  //     
  //   }
  // };




  // useEffect(() => {
  //   document.addEventListener('mousedown', handleMouseDown);

  //   return () => {
  //     document.removeEventListener('mousedown', handleMouseDown);
  //   };
  // }, []);
  const  handleKeyDown  = (event) => {
    if (event.key === 'F12') { 
      event.preventDefault();
    }
    if (event.ctrlKey && event.shiftKey) {
      
      switch (event.key) {
          case 'C':
          case 'c':
          case 'С':
          case 'с':
              event.preventDefault();
              break;
          case 'Ш':
          case 'ш':
              event.preventDefault();
              break;
          case 'I':
          case 'i':
              event.preventDefault();
              break;
          default:
              break;
      }
  }
  
  if (event.ctrlKey && event.altKey) {
      switch (event.key) {
          case 'C':
          case 'c':
          case 'С':
          case 'с':
              event.preventDefault();
              break;
          case 'I':
          case 'i':
          case 'Ш':
          case 'ш':
              event.preventDefault();
              break;
          default:
              break;
      }
  }
  if (event.ctrlKey) {
      switch (event.key) {
        case 'U':
        case 'u':
        case 'г':
        case 'Г':
            event.preventDefault();
            break;
        default:
            break;
    }
  }
  if (event.metaKey  && event.altKey) {
    switch (event.key) {
      case 'U':
      case 'u':
      case 'г':
      case 'Г':
          event.preventDefault();
          break;
      default:
          break;
  }
}
  }
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
 

  return (
    <div className="app" onContextMenu={handleContextMenu}>
      <Routes>
        {routes.map((route) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={route.component}
            />
          )
        })}
       
        <Route path="*" element={<NoMatch />} />
      </Routes>

      <WsNotifications />
     
    </div>
  )
}

export default App
